import { Heading, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { css } from 'emotion'
import React from 'react'

interface AtestadoTextBoxProps {
  descricao: string
}

export function AtestadoTextBox(props: Readonly<AtestadoTextBoxProps>) {
  const { descricao } = props

  return (
    <Box>
      <VFlow vSpacing={0.5} style={styles.content}>
        <Heading level={3}>ATESTADO</Heading>
        <Text>{descricao}</Text>
      </VFlow>
    </Box>
  )
}

const styles = {
  content: css`
    justify-content: center;
    align-items: center;
    margin: 1rem 6rem 2rem;
  `,
}
